



















import { Vue, Component, Prop } from 'nuxt-property-decorator';

import HeaderMenuNotificationsCardGrid from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGrid.vue';
import HeaderMenuNotificationsCardGridAvatar from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGridAvatar/HeaderMenuNotificationsCardGridAvatar.vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import { notificationTypes } from '@/components/global/HeaderMenu/HeaderMenuNotifications/constants';

import MoneyStackIcon from '~/assets/svg/money-stack.vue.svg';
import type { Notification } from '~/types/graphql';

@Component({
  components: {
    BravadoButtonV3,
    HeaderMenuNotificationsCardGrid,
    HeaderMenuNotificationsCardGridAvatar,
    MoneyStackIcon,
  },
})
export default class HeaderMenuNotificationsCardReferral extends Vue {
  @Prop() notification!: Notification;

  get titleText() {
    if (this.notification.type === notificationTypes.REFERRAL) {
      return `Wow, great news, ${this.$auth.user!.firstname}! You got hired 💰`;
    }

    return `Wow, great news, ${this.$auth.user!.firstname}! Your friend got hired 💰`;
  }
}
